import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';
import backgroundImage from '../../../../screens/Login/components/LoginBackground/assets/BuildingsDark.svg';

export const login: ThemeApp['appComponents']['login'] = {
  login: {
    formContainer: {
      backgroundColor: themeUi.semantic.color.text.secondary950,
      boxShadow: 'none',
      border: `1px solid ${themeUi.semantic.color.text.secondary800}`,
      color: themeUi.semantic.color.text.secondary0
    },

    background: {
      backgroundColor: themeUi.semantic.color.background.secondary990,
      backgroundImage: `url(${backgroundImage})`
    },

    loader: {
      backgroundColor: `color-mix(in srgb, ${themeUi.semantic.color.text.secondary950} 70%, transparent)`
    }
  },

  components: {
    forgotPasswordForm: {
      forgotPasswordTitle: {
        color: themeUi.semantic.color.text.secondary200
      },
      forgotPasswordDescription: {
        color: themeUi.semantic.color.text.secondary400
      }
    },

    mobileBanner: {
      bannerContainer: {
        backgroundColor: themeUi.semantic.color.background.neutral100
      },
      heading: {
        color: themeUi.semantic.color.text.secondary200
      },
      body: {
        color: themeUi.semantic.color.text.secondary400
      }
    },

    orSeperator: {
      orText: {
        color: themeUi.semantic.color.text.secondary0,
        backgroundColor: themeUi.semantic.color.background.secondary800
      }
    },

    resetPassword: {
      resetPasswordFormTitle: {
        color: themeUi.semantic.color.text.secondary200
      }
    },

    signInForm: {
      signInTitle: {
        color: themeUi.semantic.color.text.secondary0
      }
    },

    signInFromUserInvitation: {
      signInTitle: {
        color: themeUi.semantic.color.text.secondary200
      },
      setPasswordFormTitle: {
        color: themeUi.semantic.color.text.secondary200
      }
    },

    signUp: {
      components: {
        signUpForm: {
          inlineTerms: {
            color: themeUi.semantic.color.text.secondary400,
            checkboxColor: themeUi.semantic.color.text.primary400
          },
          bigTitleRules: {
            color: themeUi.semantic.color.text.secondary200
          },
          formTitle: {
            color: themeUi.semantic.color.background.neutral500
          }
        }
      }
    },

    socialLogin: {
      socialLoginButton: {
        socialLoginName: {
          color: themeUi.semantic.color.text.secondary0
        }
      }
    },

    ssoLoginForm: {
      signInTitle: {
        color: themeUi.semantic.color.text.secondary200
      }
    },

    userFormInfo: {
      userFormInfoTitle: {
        color: themeUi.semantic.color.text.secondary200
      },
      userFormInfoSubTitle: {
        color: themeUi.semantic.color.text.secondary200
      },
      userFormInfoText: {
        color: themeUi.semantic.color.text.secondary400
      }
    }
  },

  loginPromo: {
    backgroundImageContainer: {
      backgroundColor: themeUi.semantic.color.background.secondary990
    }
  }
};
